// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"88":"browse","270":"my-favourites","499":"my-sessions","596":"404","922":"edit"}[chunkId] || chunkId) + "." + {"65":"52c732f4","88":"5f8f5373","134":"1718a87b","270":"2ef66925","374":"8c0cb711","431":"cf313502","499":"94540d06","596":"c50ad9f4","922":"8f59afd3"}[chunkId] + ".js";
};